import React from "react";

export class Timer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { time: {}, seconds: props.seconds };
    this.timerId = null;
  }

  componentDidMount() {
    let timeLeftVar = this.secondsToTime(this.state.seconds);
    this.setState({ time: timeLeftVar });
    this.startTimer();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.seconds && prevProps.seconds !== this.props.seconds) {
      if (this.timerId) {
        clearInterval(this.timerId);
        let timeLeftVar = this.secondsToTime(this.props.seconds);
        this.setState({ time: timeLeftVar });
        this.startTimer();
      }
    }
  }

  componentWillUnmount() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  }

  secondsToTime(secs) {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
      h: hours,
      m: minutes,
      s: seconds,
    };
    return obj;
  }

  startTimer = () => {
    this.timerId = setInterval(this.countDown, 1000);
    this.endTimeInMs = Date.now() + this.props.seconds * 1000;
  }

  countDown = () => {
    const dateNow = Date.now();
    const newTime = Math.round((this.endTimeInMs - dateNow)  / 1000);
    this.setState({
      time: this.secondsToTime(newTime),
    });

    // Check if we're at zero.
    if (dateNow >= this.endTimeInMs) {
      this.props.onEnd();
      if (this.timerId) {
        clearInterval(this.timerId);
      }
    }
  }

  render() {
    return (
      <span>
        {("0" + this.state.time.m).slice(-2)}:
        {("0" + this.state.time.s).slice(-2)}
      </span>
    );
  }
}

export default Timer;
